module.exports = __webpack_public_path__ + "static/Site-11-fa0def374738297be4b8ee6099e8a598.jpg";